import { render } from "./Thread.vue?vue&type=template&id=27666bb4&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"

import "./Thread.vue?vue&type=style&index=0&id=27666bb4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27666bb4"]])

export default __exports__